/**
 * Append a `[[meetingId]]` wiki link under a `## Meetings` (or `## Möten`) heading.
 * Mirrors the server-side helper in `backend/transcription/meeting-processor.ts`.
 * Idempotent — returns unchanged content if the link is already present.
 */
export function appendMeetingLinkToContent(
  contentMd: string,
  meetingEntryId: string,
  meetingTitle: string,
  locale: string,
): string {
  const content = contentMd || ''

  if (content.includes(`[[${meetingEntryId}]]`)) return content

  const isSv = locale.startsWith('sv')
  const date = new Date().toLocaleDateString(isSv ? 'sv-SE' : 'en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
  const linkLine = `- [[${meetingEntryId}]] ${meetingTitle} (${date})`
  const meetingsHeading = isSv ? '## Möten' : '## Meetings'
  const headingIndex = content.indexOf(meetingsHeading)

  if (headingIndex !== -1) {
    const afterHeading = headingIndex + meetingsHeading.length
    const nextNewline = content.indexOf('\n', afterHeading)
    if (nextNewline !== -1) {
      const insertPos = nextNewline + 1
      const nextChar = content[insertPos]
      const actualInsert = nextChar === '\n' ? insertPos + 1 : insertPos
      return content.slice(0, actualInsert) + linkLine + '\n' + content.slice(actualInsert)
    }
    return content + '\n' + linkLine + '\n'
  }

  const sep = content.length > 0 && !content.endsWith('\n\n')
    ? (content.endsWith('\n') ? '\n' : '\n\n')
    : ''
  return content + sep + `${meetingsHeading}\n\n${linkLine}\n`
}
